import { api } from "@/lib/api";

// GoHighLevel swap points. Set an embed URL to replace the native form/calendar with a GHL iframe.
// When a GHL webhook is added, submitLead can forward there instead of (or in addition to) the site API.
export const GHL = {
  connected: false,
  embeds: {
    eligibility: null,
    enroll: null,
    tour: null,
    transportation: null,
    callback: null,
  },
  tourCalendar: null,
  webhookUrl: null,
};

// Tags line up with future GHL tags/pipelines, e.g. "form:enroll", "scene:overnight-care".
export const leadTags = (lead) => [`form:${lead.form_type}`, `scene:${lead.scene}`];

export async function submitLead(lead) {
  const { data } = await api.post("/leads", lead);
  return { ...data, tags: leadTags(lead) };
}
